import React from "react"
import { Link } from "react-router-dom"

export default function ContactInfo() {
	return (
		<section className="contact-info-section fix section-padding">
			<div className="container">
				<div className="section-title text-center">
					<h6 className="wow fadeInUp">
						<i className="fa-regular fa-arrow-left-long" />
						CONTACT US
						<i className="fa-regular fa-arrow-right-long" />
					</h6>
					<h2 className="wow fadeInUp" data-wow-delay=".4s">
						Our Contact Information
					</h2>
				</div>
				<div className="row">
					<div
						className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 wow fadeInUp"
						data-wow-delay=".2s"
					>
						<div className="contact-box-items" style={{ height: "300px" }}>
							<div className="icon">
								<img src="assets/img/icon/18.svg" alt="img" />
							</div>
							<div className="content">
								<h3>Our Address</h3>
								<p>
									No. 447/2, Sy No.26/4B1 , N.H.7 , Balagaranahalli Village Hosur Road, Near By Nayara Petrol Pump, Attibele Post, Bengaluru Urban, Bengaluru-562107, Karnataka, India
								</p>
							</div>
						</div>
					</div>
					<div
						className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 wow fadeInUp"
						data-wow-delay=".4s"
					>
						<div className="contact-box-items" style={{ height: "300px" }}>
							<div className="icon">
								<img src="assets/img/icon/19.svg" alt="img" />
							</div>
							<div className="content">
								<h3>Email Address</h3>
								<p>
									Mobile: <a href="tel:+917022565599">+91 7022565599</a>{" "}
									<br />
									Email : {""}
									<a href="mailto:info@vmakewpc.com">info@vmakewpc.com</a>
								</p>
							</div>
						</div>
					</div>
					<div
						className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 wow fadeInUp"
						data-wow-delay=".6s"
					>
						<div className="contact-box-items" style={{ height: "300px" }}>
							<div className="icon">
								<img src="assets/img/icon/20.svg" alt="img" />
							</div>
							<div className="content">
								<h3>Hours of Operation</h3>
								<p>
									Monday-Saturday : <br />8 AM - 9 PM <br /> Sunday : Closed
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
